
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.042","height":"19.93"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.022.75a4.12 4.12 0 104.12 4.12A4.125 4.125 0 009.022.75zM.798 19.18h16.447a8.24 8.24 0 00-16.447 0z","fill":"none"}})])
          )
        }
      }
    